/** 토스 결제위젯 클라이언트 키 (테스트/운영 분리). */
export function getTossClientKey(): string | undefined {
  const isDev = process.env.REACT_APP_NODE_ENV === "dev";
  if (isDev) {
    return (
      process.env.REACT_APP_TOSS_CLIENT_KEY_TEST ??
      process.env.REACT_APP_TOSS_CLIENT_KEY
    );
  }
  return process.env.REACT_APP_TOSS_CLIENT_KEY;
}
